<template>
  <div v-if="filteredRuns.length > 0">
    <span class="label info">TERM</span>
    <h5 class="mbn">
      <strong>
        {{ term.termName }}
      </strong>
    </h5>
    <p class="mbn small">{{ termStartTime }} - {{ termEndTime }}</p>
    <a
        class="smaller mbs"
        v-if="showWaitingListResults"
        v-on:click.prevent="toggleWaitingLists"
    >{{ runsThatHaveAWaitingListToJoin.length }} Waiting List{{
        runsThatHaveAWaitingListToJoin.length > 1 ? 's' : ''
      }}
      Available to Join</a
    >

    <div class="row" v-if="filteredRuns.length > 0">
      <div class="columns large-12">
        <table class="full-width">
          <thead>
          <tr>
            <th colspan="2">Day & Time</th>
<!--            <th class="show-for-medium-up">Time</th>-->
            <th class="show-for-medium-up">Venue</th>
            <th>Class</th>
            <th class="show-for-medium-up"></th>
          </tr>
          </thead>
          <tbody>
          <tr
              is="run-component"
              v-for="(run) in filteredRuns"
              :run="run"
              :key="'run:' + run.runStartTime + ':' + run.runId"
          ></tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" v-else>
      <div class="columns">
        <div class="panel pal">
          <h6 class="show-for-medium-up">
            {{ noAvailableRunsText }}
          </h6>
          <p class="show-for-small">{{ noAvailableRunsText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RunComponent from './Run';
import moment from 'moment';

export default {
  name: 'Term',
  data() {
    return {};
  },

  props: ['term'],

  methods: {

    dayFilter(run) {
      const { day } = this.$store.getters;
      if (day === 'any') {
        return true;
      }
      const sessions = Object.values(run.sessions).map((session) => {return session.day.toLowerCase()});
      return sessions.includes(day);
    },
    daysFilter(run) {
      var runDay = moment
          .utc(run.runStartTime * 1000)
          .format('ddd')
          .toLowerCase();
      var filterDays = this.$store.getters.days;

      if (filterDays.length > 0) {
        if (filterDays.indexOf(runDay) != -1) {
          return true;
        }
      } else {
        return true;
      }
    },

    classFilter(run) {
      const runClass = run.className.toLowerCase();
      const filterClass = this.$store.getters.className.toLowerCase();
      return filterClass === 'any' || runClass === filterClass;
    },

    venueFilter(run) {
      const runVenue = run.venueName.toLowerCase();
      const filterVenue = this.$store.getters.venueName.toLowerCase();
      return filterVenue === 'any' || runVenue === filterVenue;
    },
    onlyAvailableToBookRunsFilter(run) {
      if (this.$store.getters.onlyAvailableRuns) {
        return parseInt(run.bookingsCount, 10) < parseInt(run.capacity, 10);
      } else {
        return true;
      }
    },

    onlyForASpecificAgeFilter(run) {
      var filterValue = this.$store.getters.ageFilterValue;

      if (!filterValue) {
        return run;
      }

      if (this.$store.getters.ageFilterUnit == 'years') {
        var ageFrom = run.ageFrom / 12;
      } else {
        var ageFrom = run.ageFrom;
      }

      return ageFrom < filterValue;
    },

    onlyForASpecificAgeSelectFilter(run) {
      var filterValue = this.$store.getters.selectedAge;
      var ageFrom = run.ageFrom;
      var ageTo = run.ageTo;

      if (filterValue == 'any' || (ageFrom == 0 && ageTo == 0)) {
        return run;
      } else if (filterValue < 1) {
        return ageTo > 0 && ageFrom < 12;
      } else if (filterValue == 11) {
        return ageTo >= 132;
      } else {
        return (
            Math.floor(ageTo / 12) >= filterValue &&
            Math.floor(ageFrom / 12) <= filterValue
        );
      }
    },

    onlyForASpecificTimeFilter(run) {
      var morningFilter = this.$store.getters.timeFilterMorning;
      var afternoonFilter = this.$store.getters.timeFilterAfternoon;
      var eveningFilter = this.$store.getters.timeFilterEvening;

      // default state
      if (!morningFilter && !afternoonFilter && !eveningFilter) {
        return run;
      }

      var runStartTimeIn24HourTime = moment
          .utc(run.runStartTime * 1000)
          .format('HH');

      if (morningFilter) {
        return runStartTimeIn24HourTime < 12;
      }

      if (afternoonFilter) {
        return (
            runStartTimeIn24HourTime >= 12 &&
            runStartTimeIn24HourTime < 16
        );
      }

      if (eveningFilter) {
        return runStartTimeIn24HourTime >= 16;
      }
    },

    onlyForASpecificTimeSelectFilter(run) {
      const { availableTime } = this.$store.getters;

      if (availableTime == 'any') {
        return run;
      }

      let times = Object.values(run.classTimes);

      for(var i = 0; i < times.length; i++) {
        const { starttime } = times[i];
        const { hours } = starttime;
        const startHour = parseInt(hours, 10);
        return (availableTime === 'Morning' && startHour < 12) || (availableTime === 'Afternoon' && startHour >= 12 && startHour < 16) || (availableTime === 'Evening' && startHour >= 16);
      }

    },

    sortByClosestVenue(run, radius) {
      // $latitude = $request->get('latitude', '55.9203186');
      // $longitude = $request->get('longitude', '-4.3337798');
      var radius = 5;

      // 'Caching' these variables to prevent repeated function calls
      var longitudeInRadians =
          this.$store.getters.longitude * (Math.PI / 180);

      var cosineOfTheLatitude = Math.cos(
          this.$store.getters.latitude * (Math.PI / 180)
      );
      var sineOfTheLatitude = Math.sin(
          this.$store.getters.latitude * (Math.PI / 180)
      );
      // cache this for the craic as well
      var runLatitudeInRadians = run.latitude * (Math.PI / 180);

      // debugger;
      // work out the distance from the long and lat passed in
      var distance =
          3959 *
          Math.acos(
              cosineOfTheLatitude *
              Math.cos(runLatitudeInRadians) *
              Math.cos(
                  run.longitude * (Math.PI / 180) - longitudeInRadians
              ) +
              sineOfTheLatitude * Math.sin(runLatitudeInRadians)
          );

      return radius < distance;
    },

    toggleWaitingLists() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          onlyAvailableRuns: !this.$store.getters.onlyAvailableRuns
        })
      });
      this.$store.commit(
          'UPDATE_AVAILABLE_RUNS_FILTER',
          !this.$store.getters.onlyAvailableRuns
      );
    },

		timeSort(a, b) {
		//sort by earliest class start - ensures we pick 1st day if there are multiple
		const aDow = Object.values(a.classTimes)[0].dow;
		const aHours = Object.values(a.classTimes)[0].starttime.hours;
		const aMins = Object.values(a.classTimes)[0].starttime.mins;

		const bDow = Object.values(a.classTimes)[0].dow;
		const bHours = Object.values(b.classTimes)[0].starttime.hours;
		const bMins = Object.values(b.classTimes)[0].starttime.mins;

		return (aDow + aHours + aMins) - (bDow + bHours + bMins);
		},
	
		daySort(a, b) {
 			return (Object.values(a.classTimes)[0].dow > Object.values(b.classTimes)[0].dow) - (Object.values(a.classTimes)[0].dow < Object.values(b.classTimes)[0].dow)
		}
  },

  computed: {
    termStartTime() {
      return moment
          .utc(this.term.termStartDateTime * 1000)
          .format('ddd Do MMMM YYYY');
    },
    termEndTime() {
      return moment
          .utc(this.term.termEndDateTime * 1000)
          .format('ddd Do MMMM YYYY');
    },
    runs() {
      return Object.values(this.term.runs);
    },
    filteredRuns() {
      return (
          this.runs
              .filter(this.dayFilter)
              .filter(this.classFilter)
              .filter(this.venueFilter)
              .filter(this.onlyAvailableToBookRunsFilter)
              .filter(this.onlyForASpecificAgeSelectFilter)
              .filter(this.onlyForASpecificTimeSelectFilter)
              .sort(this.timeSort)
              .sort(this.daySort)
              
      


      );

      // .sort(this.sortByClosestVenue);
    },
    runsThatHaveAWaitingListToJoin() {
      return this.runs.filter(function (run) {
        return parseInt(run.bookingsCount) >= parseInt(run.capacity);
      });
    },

    termId() {
      return '#term' + this.term.termId;
    },
    termPanelId() {
      return 'term' + this.term.termId;
    },

    showWaitingListResults() {
      return (
          this.runsThatHaveAWaitingListToJoin.length > 0 &&
          this.$store.getters.onlyAvailableRuns == true
      );
    },

    noAvailableRunsText() {
      var textString = 'No classes available for booking';

      // if(this.runsThatHaveAWaitingListToJoin.length > 0) {
      //     textString += ', ' + this.runsThatHaveAWaitingListToJoin.length + ' waiting list'+ this.runsThatHaveAWaitingListToJoin.length > 1 ? 's' : '' + ' available';
      // }

      return textString;
    }
  },

  components: {
    RunComponent
  },

  mounted() {
  },
  updated() {
  }
};
</script>

<style scoped></style>
